import React, { Component } from "react";
import { Grid, TextField, Button, Dialog, Typography, DialogTitle, DialogContent, DialogActions, IconButton } from '@material-ui/core';
import AssignEngineer from '../assign-engineer/assign-engineer';
import { saveJob } from '../services/jobs-service';
import { timeslots } from '../services/timeslot';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CloseIcon from '@material-ui/icons/Close';

import "./add-edit-job-modal.css";

export default class AddEditJobModal extends Component {
    constructor() {
        super();

        this.state = {
            engineerList: [],
            job: {
                addressLine1: null,
                addressLine2: null,
                postCode: null,
                city: null,
                description: null,
                notes: null,
                jobNumber: null,
            },
            assignments: [],
        };
    };

    onEnter = () => {
        this.setState({ 
            job: this.props.job,
            assignments: this.props.job.assignments 
        });
    };

    addEngineer = (engineerId) => {
        const assignments = this.state.assignments;
        assignments.push(this.createNewAssignment(engineerId));
        this.setState({ assignments: assignments });
    };

    createNewAssignment = (engineerId) => {
        return {
            id: this.state.assignments.length + 1,
            engineerId: engineerId ? engineerId : 0,
            jobId: this.state.job.id,
            duration: 0.5,
            appointmentDate: this.props.appointmentDate,
            appointmentTime: null,
            timeslot: "AT",
            value: 0
        };
    };

    onJobFieldChange = (event) => {
        const job = this.state.job;

        job[event.target.name] = event.target.value;

        this.setState({ job: job });
    };

    onAssignmentValueChange = (fieldName, value, assignmentId) => {
        const assignments = this.state.assignments;
        const assignmentToChange = assignments.find(x => x.id === assignmentId);

        assignmentToChange[fieldName] = value;
        
        this.setState({ assignments: assignments });
    };

    onAssignmentAppointmentTimeChange = (event, assignmentId) => {
        const assignments = this.state.assignments;
        const assignmentToChange = assignments.find(x => x.id === assignmentId);

        assignmentToChange.timeslot = event.timeslot;
        assignmentToChange.appointmentTime = event.appointmentTime;

        if (assignmentToChange.appointmentTime != null)
            assignmentToChange.timeslot = "ST";

        this.setState({ assignments: assignments });
    };

    save = (event) => {
        if (!this.validate()) {
            alert('Please make sure all values have been entered and at least one engineer has been assigned.');
            return;
        }

        const assignments = [];

        for (var stateAssignment of this.state.assignments) {
            let assignment = { ...stateAssignment };

            assignment.duration = Number(stateAssignment.duration);
            assignment.timeslot = timeslots.values[stateAssignment.timeslot];
            assignment.value = Number(stateAssignment.value);

            assignments.push(assignment);
        }

        const jobManagementDto = { ...this.state.job };
        jobManagementDto.assignments = assignments;

        saveJob(jobManagementDto)
            .then(() => this.props.onJobSaved())
            .catch(error => {
                alert("Unable to save job");
                console.error(error);
            });

        this.close();
    };

    validate = () => {
        return this.state.job.addressLine1 != null && this.state.job.description != null && this.state.job.jobNumber != null && this.state.assignments.length > 0;
    };

    close = () => {
        this.setState({
            job: {
                addressLine1: null,
                addressLine2: null,
                postCode: null,
                city: null,
                description: null,
                notes: null,
                jobNumber: null,
            }, 
            assignments: [] 
        });

        this.props.onModalClosed();
    };

    removeAssignment = (assignmentId) => {
        const assignments = this.state.assignments;

        if (assignments.length <= 1) {
            return;
        }

        assignments.splice(this.state.assignments.findIndex(x => x.id === assignmentId), 1);
        this.setState({ assignments: assignments });
    };

    render() {
        return (<Dialog
            open={this.props.isOpen}
            onClose={this.close}
            onEnter={this.onEnter}
            maxWidth={false}
            fullWidth={true}
            scroll="body">
            <DialogTitle onClose={this.close}>
                <Grid container justify="space-between">
                    <Grid item xs={11}>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <TextField 
                                    autoFocus 
                                    required 
                                    fullWidth
                                    label="Job Number"  
                                    name="jobNumber" 
                                    value={this.state.job.jobNumber}
                                    onChange={this.onJobFieldChange} />
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField 
                                    required 
                                    fullWidth
                                    label="Description" 
                                    name="description"  
                                    value={this.state.job.description}
                                    onChange={this.onJobFieldChange} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>
                        <Grid item container justify="flex-end">
                            <Grid item xs="auto">
                                <IconButton color="primary" onClick={this.close}>
                                    <CloseIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container justify="space-between" spacing={2}>
                    <Grid item xs={12} sm={9}>
                        <TextField 
                            multiline
                            fullWidth 
                            rows="15" 
                            label="Notes" 
                            name="notes" 
                            value={this.state.job.notes}
                            onChange={this.onJobFieldChange} />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Grid
                            container
                            direction="column"
                            spacing={2}>
                            <Grid item xs="auto">
                                <TextField
                                    required
                                    fullWidth
                                    label="Address Line 1"
                                    name="addressLine1"
                                    value={this.state.job.addressLine1}
                                    onChange={this.onJobFieldChange} />
                            </Grid>
                            <Grid item xs="auto">
                                <TextField 
                                    fullWidth
                                    label="Address Line 2" 
                                    name="addressLine2" 
                                    value={this.state.job.addressLine2}
                                    onChange={this.onJobFieldChange} />
                            </Grid>
                            <Grid item xs="auto">
                                <TextField 
                                    fullWidth
                                    label="City" 
                                    name="city" 
                                    value={this.state.job.city}
                                    onChange={this.onJobFieldChange} />
                            </Grid>
                            <Grid item xs="auto">
                                <TextField 
                                    fullWidth
                                    label="Post Code" 
                                    name="postCode" 
                                    value={this.state.job.postCode} 
                                    onChange={this.onJobFieldChange} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container justify="flex-start" spacing={2}>
                    <Grid item xs={12}>
                        <IconButton color="primary" onClick={this.addEngineer}>
                            <AddBoxIcon fontSize="large" />
                            <Typography variant="button">Add Engineer</Typography>
                        </IconButton>
                    </Grid>
                    {this.state.assignments.map((assignment, index) => {
                        return (<Grid item xs={12} sm={3} key={index}>
                            <AssignEngineer
                                assignmentId={assignment.id}
                                engineerList={this.props.engineerList}
                                engineerId={assignment.engineerId}
                                appointmentDate={assignment.appointmentDate}
                                appointmentTime={assignment.appointmentTime}
                                timeslot={assignment.timeslot}
                                duration={assignment.duration}
                                value={assignment.value}
                                allowRemove={this.state.assignments.length > 1}
                                onAppointmentTimeChange={this.onAssignmentAppointmentTimeChange}
                                onRemoveAssignment={this.removeAssignment}
                                onAssignmentValueChange={this.onAssignmentValueChange} />
                        </Grid>)
                    })}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disableElevation color="primary" onClick={this.close}>
                    Cancel
                </Button>
                <Button variant="contained" disableElevation color="primary" onClick={this.save}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>);
    }
}